export default __webpack_public_path__ + "static/media/ShareTheWin_159x150.19b9ab06.png";